import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useEffect } from 'react';
import UIButton from 'UIComponents/button/UIButton';
import UITileSection from 'UIComponents/tile/UITileSection';
import { FeedbackContainer, SuccessIllustration, ThankYouMessage, ThankYouTextContainer, ThankYouTitle } from './feedback.styles';
export const ThankYouScreen = ({
  shouldDisplayFeedbackWidget
}) => {
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      shouldDisplayFeedbackWidget(false);
    }, 3000);
    return () => {
      clearTimeout(timeoutId);
    };
  }, [shouldDisplayFeedbackWidget]);
  return /*#__PURE__*/_jsx(FeedbackContainer, {
    closeable: true,
    id: "feedback-widget-container",
    onClose: () => {
      shouldDisplayFeedbackWidget(false);
    },
    children: /*#__PURE__*/_jsxs(UITileSection, {
      children: [/*#__PURE__*/_jsx(SuccessIllustration, {
        name: "successfully-submitted-question"
      }), /*#__PURE__*/_jsxs(ThankYouTextContainer, {
        className: "m-y-4",
        children: [/*#__PURE__*/_jsx(ThankYouTitle, {
          className: "m-x-2",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: 'feedbackWidget.thankYou.title'
          })
        }), /*#__PURE__*/_jsx(ThankYouMessage, {
          className: "m-x-2",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: 'feedbackWidget.thankYou.message'
          })
        }), /*#__PURE__*/_jsx(UIButton, {
          className: "text-center m-all-auto m-top-2",
          responsive: false,
          use: "transparent",
          onClick: () => shouldDisplayFeedbackWidget(false),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: 'feedbackWidget.thankYou.close'
          })
        })]
      })]
    })
  });
};